import Lenis from 'lenis';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const isFrontendContext = () => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
};

const prefersReducedMotion = () => {
  if (!window.matchMedia) {
    return false;
  }

  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
};

const escapeSelector = (value) => {
  if (window.CSS?.escape) {
    return window.CSS.escape(value);
  }

  return value.replace(/([ #;?%&,.+*~\\':"!^$[\]()=>|/@])/g, '\\$1');
};

const resolveAnchorTarget = (hash) => {
  if (!hash || hash === '#') {
    return null;
  }

  const id = hash.slice(1);

  if (!id) {
    return null;
  }

  let target = document.getElementById(id);

  if (!target) {
    target = document.querySelector(`[name="${escapeSelector(id)}"]`);
  }

  return target;
};

const bindAnchorScroll = () => {
  if (window.__rvLenisAnchorBound) {
    return;
  }

  window.__rvLenisAnchorBound = true;

  document.addEventListener('click', (event) => {
    if (!window.rvLenis) {
      return;
    }

    const anchor = event.target.closest('a[href]');

    if (!anchor) {
      return;
    }

    const href = anchor.getAttribute('href');

    if (!href || href === '#') {
      return;
    }

    const url = new URL(href, window.location.href);

    const isSamePage =
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname;

    if (!isSamePage || !url.hash) {
      return;
    }

    const target = resolveAnchorTarget(url.hash);

    if (!target) {
      return;
    }

    event.preventDefault();

    window.rvLenis.scrollTo(target, {
      duration: 1.15,
      lock: false,
    });

    if (window.history?.pushState) {
      window.history.pushState({}, '', url.hash);
    }
  });
};

const startRafLoop = (lenis) => {
  if (window.__rvLenisRafStarted) {
    return;
  }

  window.__rvLenisRafStarted = true;

  const raf = (time) => {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
  };

  window.requestAnimationFrame(raf);
};

const initSmoothScroll = () => {
  if (!isFrontendContext()) {
    return;
  }

  if (prefersReducedMotion()) {
    return;
  }

  if (window.rvLenis) {
    bindAnchorScroll();
    return;
  }

  const lenis = new Lenis({
    duration: 1.15,
    smoothWheel: true,
    smoothTouch: false,
    touchMultiplier: 1.2,
    wheelMultiplier: 1,
    easing: (t) => 1 - Math.pow(1 - t, 3),
  });

  window.rvLenis = lenis;

  bindAnchorScroll();
  startRafLoop(lenis);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSmoothScroll, { once: true });
} else {
  initSmoothScroll();
}
